module.exports = __webpack_public_path__ + "img/hacienda-room-6.b05a953c.jpg";